import { CodeEditor } from "@/components/CodeEditor"

import { useCraftProp } from "../utils"

export default function CodeEditorProperty({ name, type, ...props }) {
  const { value, setValue } = useCraftProp(name)

  return <CodeEditor
    value={value}
    onChange={setValue}
    height='100px'
    language={type}
    {...props}
  />
}

